import React, { useState, useLayoutEffect, useEffect } from 'react'
import Slider from '@mui/material/Slider';
import './Footer.scss'
import { ReactComponent as NextIcon } from "../assets/svg/footer/next.svg";
import { ReactComponent as PlayIcon } from "../assets/svg/footer/play.svg";
import { ReactComponent as PauseIcon } from "../assets/svg/footer/pause.svg";
import { ReactComponent as SpeakerIcon } from "../assets/svg/footer/speaker.svg";
import { ReactComponent as RightwardIcon } from "../assets/svg/footer/rightward.svg";
import { ReactComponent as SmallPlayIcon } from "../assets/svg/footer/smallPlay.svg";
import { useSelector, useDispatch } from 'react-redux';
import { footerListBtnClicked, footerGreenAreaClicked } from '../redux/actions/index';
var timer;

function Footer() {
    const totalTimeSliderValue = 1000000;
    const [totalWaveSliderValue, setTotalWaveSliderValue] = useState((Math.max(window.innerWidth - 970, 10) / 5).toFixed(0))
    const defaultTimeSliderValue = 300000; ///<--------------------------delete
    const totalTime = useSelector(state => state.footer.totalTime);
    
    const playList = useSelector(state => state.footer.playList);
    const waveSliderFlag = useSelector(state => state.footer.waveSliderFlag);
    const [timeSliderValue, setTimeSliderValue] = useState(defaultTimeSliderValue);
    const [mouseDownFlag, setMouseDownFlag] = useState(false)
    const [playBtnFlag, setPlayBtnFlag] = useState(false)
    // const [gotoTime, setGotoTime] = useState("00:00");
    const dispatch = useDispatch()
    const footerListBtnClickeD = () => {
        dispatch(footerListBtnClicked());
    }
    const footerGreenAreaClickeD = () => {
        dispatch(footerGreenAreaClicked());
    }
    useLayoutEffect(() => {
        function updateSize() {
            setTotalWaveSliderValue((Math.max(window.innerWidth - 970, 10) / 5).toFixed(0))
        }
        window.addEventListener('resize', updateSize);
        updateSize();
        return () => window.removeEventListener('resize', updateSize);
    }, []);
    useEffect(() => {
        timer = window.setInterval(() => {
            if(timeSliderValue < totalTimeSliderValue && playBtnFlag){
                setTimeSliderValue(timeSliderValue + (totalTimeSliderValue / totalTime / 20))
            }
            else{
                setPlayBtnFlag(false);
            }
        }, 50);
        return () => {
            window.clearInterval(timer);
        };
    });
    function secondToFormat(second) {
        let sec = second.toFixed(0);
        let hour = (sec / 3600).toFixed(0);
        sec = sec % 3600;
        let min = (sec / 60).toFixed(0);
        sec = sec % 60;
        let formatString = "";
        if (hour > 0) {
            if (hour < 10) hour = '0' + hour;
            hour = hour + ":";
            formatString = hour;
        }
        if (min < 10) min = '0' + min;
        if (sec < 10) sec = '0' + sec;
        formatString = formatString + min + ":" + sec;
        return formatString;
    }
    function randomHeight() {
        return Math.floor(Math.random() * (50 - 35 + 1)) + 35;
    }
    function getWaveSliderValue() {
        return timeSliderValue * totalWaveSliderValue / totalTimeSliderValue;
    }
    return (
        <div className='Footer'>
            <div className={playList.flag ? (waveSliderFlag ? "play-list high" : "play-list") : "hidden"}>
                <table style={{ width: '100%' }}>
                    <tbody>
                        <tr>
                            {
                                playList?.headers?.map((item, index) => {
                                    return (
                                        <th key={"playListheader" + index}>
                                            {item}
                                        </th>
                                    )
                                })
                            }
                        </tr>
                        {
                            playList?.items?.map((line, lineIndex) => {
                                return (
                                    <tr key={"playListLine" + lineIndex}>
                                        {
                                            line?.map((item, index) => {
                                                if (index === 0) return <td className="item-id" key={"playListItem" + lineIndex + "-" + index}>{lineIndex + 1}</td>;
                                                if (index === 1) return <td key={"playListItem" + lineIndex + "-" + index}><SmallPlayIcon /></td>;
                                                return <td key={"playListItem" + lineIndex + "-" + index}><u>{item}</u></td>
                                            })
                                        }
                                    </tr>
                                )
                            })
                        }
                    </tbody>
                </table>
            </div>
            <div className={waveSliderFlag ? 'green-area big' : 'green-area'} onClick={footerGreenAreaClickeD}></div>
            <div className='main-area'>
                <div className='left'>
                    <div className={waveSliderFlag ? 'title-author small' : 'title-author'}>
                        <p className='title'>Titolo brano</p>
                        <p className='author'>Artista</p>
                    </div>
                    <div className='player-buttons'>
                        <NextIcon className='rotate-back' />
                        <PlayIcon  className={playBtnFlag? 'hidden' : ''} onClick={()=>{setPlayBtnFlag(!playBtnFlag)}}/>
                        <PauseIcon className={playBtnFlag? '' : 'hidden'} onClick={()=>{setPlayBtnFlag(!playBtnFlag)}}/>
                        <NextIcon />
                    </div>
                </div>
                <div className='center'>
                    {/* <input
                        type="time"
                        onChange={ev => setGotoTime(ev.target.value)}
                        min="00:00"
                        max="23:59"
                        // step="60"
                        value={gotoTime}
                    /> */}
                    <p className='time-displaying left'>
                        {secondToFormat(timeSliderValue * totalTime / totalTimeSliderValue)}
                    </p>
                    <Slider className={waveSliderFlag ? 'hidden' : 'time-slider'} aria-label="Progress" defaultValue={defaultTimeSliderValue}
                        value={timeSliderValue} onChange={(e) => {
                            setTimeSliderValue(e.target.value)
                        }}
                        step={1} min={0} max={totalTimeSliderValue}
                        sx={{
                            color: '#6AA72A',
                            '& .MuiSlider-thumb': {
                                height: 0,
                                width: 0,
                                boxShadow: 'none',
                                '&:hover': {
                                    height: 15,
                                    width: 15,
                                    backgroundColor: '#603F3F',
                                    boxShadow: 'none',
                                },
                                '& .airbnb-bar': {
                                    height: 9,
                                    width: 1,
                                    marginLeft: 1,
                                    marginRight: 1,
                                },
                                '& .Mui-active': {
                                    boxShadow: 'none'
                                },
                                '& .Mui-focusVisible': {
                                    boxShadow: 'none'
                                },
                                '&:before': {
                                    boxShadow: 'none',
                                },
                            },
                            '& .MuiSlider-rail': {
                                color: '#FFFFFF',
                                height: '6px',
                                boxShadow: '0px 3px 6px #00000090',
                            },
                            '& .MuiSlider-track': {
                                borderRadius: '2px',
                            },
                        }} />
                    <div className={waveSliderFlag ? 'wave-slider' : 'hidden'}
                        onMouseDown={(e) => {
                            setMouseDownFlag(true)
                            let rect = e.target.getBoundingClientRect();
                            let x = e.clientX - rect.left;
                            setTimeSliderValue(totalTimeSliderValue * x / Math.max(window.innerWidth - 980, 10))
                        }}
                        onMouseLeave={(e) => { setMouseDownFlag(false) }}
                        onMouseUp={(e) => { setMouseDownFlag(false) }}
                        onMouseMove={(e) => {
                            if (mouseDownFlag) {
                                let rect = e.target.getBoundingClientRect();
                                let x = e.clientX - rect.left;
                                setTimeSliderValue(totalTimeSliderValue * x / (window.innerWidth - 980))
                            }
                        }}>
                        {
                            [...Array(parseInt(totalWaveSliderValue))].map((item, index) => {
                                if (index + 1 > getWaveSliderValue(timeSliderValue)) {
                                    return <div key={"wave-stick" + index} className="one-stick-brown" style={{ height: `${randomHeight()}px` }}></div>
                                }
                                return <div key={"wave-stick" + index} className="one-stick-green" style={{ height: `${randomHeight()}px` }}
                                ></div>
                            })
                        }
                    </div>
                    <p className='time-displaying right'>{secondToFormat(totalTime)}</p>
                </div>
                <div className='right'>
                    <div className='volume-control'>
                        <SpeakerIcon />
                        <div className='line'>
                            <Slider aria-label="Volume" defaultValue={30}
                                sx={{
                                    color: '#6AA72A',
                                    '& .MuiSlider-thumb': {
                                        height: 0,
                                        width: 0,
                                        boxShadow: 'none',
                                        '&:hover': {
                                            height: 15,
                                            width: 15,
                                            backgroundColor: '#603F3F',
                                            boxShadow: 'none',
                                        },
                                        '& .airbnb-bar': {
                                            height: 9,
                                            width: 1,
                                            marginLeft: 1,
                                            marginRight: 1,
                                        },
                                        '& .Mui-active': {
                                            boxShadow: 'none'
                                        },
                                        '& .Mui-focusVisible': {
                                            boxShadow: 'none'
                                        },
                                        '&:before': {
                                            boxShadow: 'none',
                                        },
                                    },
                                    '& .MuiSlider-rail': {
                                        color: '#FFFFFF',
                                        height: '6px',
                                        boxShadow: '0px 3px 6px #00000090',
                                    },
                                    '& .MuiSlider-track': {
                                        borderRadius: '2px',
                                    },
                                }} />
                        </div>
                    </div>
                    <RightwardIcon className={playList.flag ? "rotate-clockwise" : "rotate-anti-clockwise"} onClick={footerListBtnClickeD} />
                </div>
            </div>
        </div>
    )
}

export default Footer